import React from 'react';
import BaseIcon from './BaseIcon';

class PlusSVG extends BaseIcon {
  render() {
    const { fillColor, height, width } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid"
        width={width}
        height={height}
        viewBox="0 0 60 60"
      >
        <path
          d="M51.211,51.213 C45.546,56.879 38.012,60.000 29.998,60.000 C21.985,60.000 14.451,56.879 8.786,51.213 C3.120,45.547 -0.000,38.014 -0.000,30.000 C-0.000,21.987 3.120,14.453 8.786,8.788 C14.451,3.121 21.985,0.000 29.998,0.000 C38.012,0.000 45.546,3.121 51.211,8.788 C56.878,14.453 60.000,21.987 60.000,30.000 C60.000,38.014 56.878,45.547 51.211,51.213 ZM49.797,10.202 C44.509,4.913 37.478,2.000 29.998,2.000 C22.519,2.000 15.488,4.913 10.200,10.202 C4.912,15.490 2.000,22.521 2.000,30.000 C2.000,37.480 4.912,44.511 10.200,49.798 C15.488,55.087 22.519,58.000 29.998,58.000 C37.478,58.000 44.509,55.087 49.797,49.798 C55.087,44.511 58.000,37.479 58.000,30.000 C58.000,22.521 55.087,15.490 49.797,10.202 ZM44.000,31.000 L31.000,31.000 L31.000,44.000 C31.000,44.552 30.553,45.000 30.000,45.000 C29.448,45.000 29.001,44.552 29.001,44.000 L29.001,31.000 L16.001,31.000 C15.448,31.000 15.001,30.553 15.001,30.000 C15.001,29.448 15.448,29.000 16.001,29.000 L29.001,29.000 L29.001,16.001 C29.001,15.449 29.448,15.001 30.000,15.001 C30.553,15.001 31.000,15.449 31.000,16.001 L31.000,29.000 L44.000,29.000 C44.552,29.000 45.000,29.448 45.000,30.000 C45.000,30.553 44.552,31.000 44.000,31.000 Z"
          fill={fillColor}
          fillRule="evenodd"
        />
      </svg>
    );
  }
}

export default PlusSVG;
